export enum AggregateEnum {
  somme = 'Somme',
  min = 'Minimum',
  max = 'Maximum',
  moyenne = 'Moyenne'
}
